var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['CEESAR-ApplicationLogo', _vm.url!=undefined? 'CEESAR-ApplicationLogoClickable' : ''],on:{"click":_vm.OnClick}},[_c('img',{attrs:{"src":_vm.finalImageSource}})])}
var staticRenderFns = []

export { render, staticRenderFns }